import {
  GET_ALL_PRICE_TABLE,
  SET_PRICE_TABLE_HELPER,
  GET_PRICE_TABLE
} from 'src/store/mutation-types'
export default {
  [GET_ALL_PRICE_TABLE] (state, priceTables) {
    state.priceTables = priceTables
  },
  [SET_PRICE_TABLE_HELPER] (state, helpers) {
    state.priceTableHelpers = helpers
  },
  [GET_PRICE_TABLE] (state, helpers) {
    state.priceTable = helpers
  }
}



// WEBPACK FOOTER //
// ./src/components/pricetable/store/mutations.js